import { Landmark } from "lucide-react";

export default function VenuesCard({teams}) {
  const venues =teams?.map((res)=>res.venue)
  console.log(venues, 'ooo')
  return (
    <div className="mb-6">
      <div className="rounded-2xl border border-gray-200/50 dark:border-gray-700/50 bg-white/80 dark:bg-gray-900/80 backdrop-blur shadow-lg">

        <div className="p-4">

          {/* Header */}
          <div className="flex items-center gap-2 mb-4">

            <Landmark className="w-4 h-4 text-blue-500" />

            <h2 className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
              Venues
            </h2>

            <span className="ml-auto text-[10px] px-2 py-1 rounded-full font-semibold bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300">
              {venues.length}
            </span>

          </div>

          {/* Venue Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">

            {venues.map((venue, index) => (
              <div
                key={index}
                className="
                  flex
                  items-center
                  gap-3
                  p-3
                  rounded-xl
                  border
                  border-gray-200/50
                  dark:border-gray-700/50
                  bg-gray-50/70
                  dark:bg-gray-800/40
                  hover:border-blue-500
                  transition-all
                  duration-300
                  cursor-pointer
                "
              >

                {/* Icon */}
                <div
                  className="
                    w-8
                    h-8
                    rounded-lg
                    bg-blue-500/10
                    flex
                    items-center
                    justify-center
                    shrink-0
                  "
                >
                  <Landmark className="w-4 h-4 text-blue-500" />
                </div>

                {/* Content */}
                <div className="min-w-0">

                  <span className="block text-xs font-medium text-gray-900 dark:text-white truncate">
                    {venue.venue_name}
                  </span>

                  <span className="block text-[10px] text-gray-500 dark:text-gray-400 truncate">
                    {venue.venue_city}
                  </span>

                </div>

              </div>
            ))}

          </div>

        </div>
      </div>
    </div>
  );
}